exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GridContainer__CreateFieldsColumns-module___1FcDU {\n  display: grid;\n  grid-template-columns: 48% 48%;\n  gap: 4%;\n}\n\n.GridItem__CreateFieldsColumns-module___1VQzw {\n  width: 100%;\n}\n\n.SecondColumn__CreateFieldsColumns-module___10okT {\n  background-color: rgb(238, 241, 239);\n  padding: 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"GridContainer": "GridContainer__CreateFieldsColumns-module___1FcDU",
	"GridItem": "GridItem__CreateFieldsColumns-module___1VQzw",
	"SecondColumn": "SecondColumn__CreateFieldsColumns-module___10okT"
};